import { useEffect, useRef } from 'react';

export const useDebouncedEffect = (effect, deps, delay) => {
    const callback = useRef(effect);

    useEffect(() => {
        callback.current = effect;
    }, [effect]);

    useEffect(() => {
        const handler = setTimeout(() => {
            callback.current();
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [...deps, delay]);
};

